import React, { useContext, useState } from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import GoogleMap from "../../GmapAutoComplete/GoogleMap";
import { useStyles } from "../AssetDetails/AssetDetailsFormStyles";
import { withStyles } from "@material-ui/core/styles";
import { Close } from "@material-ui/icons";
import { ApplicationDataAPI } from '../../API/ApplicationDataAPI';
import SummaryContext from '../../DocsFunding/Summary/SummaryContext';
import useAPIError from '../../APIError';
import {
	Grid,
	FormControl,
	Typography,
	DialogTitle,
	IconButton,
	Slide,
	Dialog,
	DialogContent,
	DialogActions,
} from "@material-ui/core";
import useAssetProvider from "../useAssetProvider";

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: "0.75rem 1.5rem",
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
});

const CustomDialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<DialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}>
					<Close />
				</IconButton>
			) : null}
		</DialogTitle>
	);
});

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

const AddAssetLocation = ({ locationModal, setLocationModal, setLocation, vendor }) => {
	const classes = useStyles();
	const { usStates, setIsRefresh, app } = useAssetProvider();
	const contextFun = useContext(SummaryContext);
	const { addError, setLoader } = useAPIError();


	const [address, setAddress] = useState({
		account: "",
		ownerid: "",
		name: "",
		type: "",
		street: "",
		city: "",
		zip: "",
		state: "",
		state_code: "",
		country: ""
	});
	const [googleAddress, setGoogleAddress] = useState("");

	const addNewLocation = async () => {
		const error =
			!address.name.length ||
			!address.type.length ||
			!address.city.length ||
			!address.zip.length ||
			!address.state.length ||
			!address.country.length;
		if (error) {
			alert("Please input required fields!");
			return;
		} else {
			try {
				setLoader(true);
				let locationData = {
					...address,
					account: app.lessee,
				}
				setLocation(locationData);
				await ApplicationDataAPI.addNewAssetLocation(locationData);
			} catch (error) {
				addError(error.message);
			} finally {
				setLocationModal(false);
				setLoader(false);
				setIsRefresh(true);
			}
		}
	};

	const updateMapInfo = (mapInfo) => {
		setAddress({
			...address,
			country: mapInfo.country || "",
			street: mapInfo.street || "",
			city: mapInfo.city || "",
			zip: mapInfo.zipCode || "",
			state: mapInfo.state || "",
			state_code: mapInfo.stateCode || ""
		});
		setGoogleAddress(mapInfo.location);
	};

	return (
		<Dialog
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			TransitionComponent={Transition}
			onClose={() => setLocationModal(false)}
			open={locationModal}
			maxWidth="sm"
			fullWidth
			classes={{
				root: classes.vendorDialog,
			}}>
			<CustomDialogTitle
				id="simple-dialog-title"
				onClose={() => setLocationModal(false)}>
				Add New Location
			</CustomDialogTitle>
			<DialogContent
				id="alert-dialog-description"
				dividers
				className={classes.vendorDialogContent}>
				<Grid container direction="row" spacing={(1, 2)}>
					<Grid item xs={6}>
						<TextField
							id="name"
							label="Location Name"
							required
							fullWidth
							value={address.name}
							error={address.name ? false : true}
							onChange={(e) => setAddress({ ...address, name: e.target.value })}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormControl fullWidth>
							<InputLabel id="locationTypeLabel">Location Type</InputLabel>
							<Select
								id="locationType"
								label="Location Type"
								placeholder="location type"
								labelId="locationType"
								required
								fullWidth
								value={address.type}
								error={address.type ? false : true}
								onChange={(e) => setAddress({ ...address, type: e.target.value })}>
								<MenuItem key="1" value="Billing">Billing</MenuItem>
								<MenuItem key="2" value="Business">Business</MenuItem>
								<MenuItem key="3" value="DUNS">DUNS</MenuItem>
								<MenuItem key="4" value="Asset/Equipment">Asset/Equipment</MenuItem>
								<MenuItem key="5" value="Other">Other</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid>
				<Grid container direction="row" spacing={(1, 2)}>
					<Grid item xs={12}>
						<GoogleMap
							id={"map-address-1"}
							variant="outlined"
							className="gps_address_input"
							placeholder="Address search"
							updateMapInfo={updateMapInfo}
						/>
					</Grid>
				</Grid>

				<Grid container direction="row" spacing={(1, 2)}>
					<Grid item xs={6}>
						<TextField
							id="streetAddress"
							name="streetAddress"
							label="Street Address"
							required
							fullWidth
							value={address.street}
							error={address.street ? false : true}
							onChange={(e) => {
								setAddress({ ...address, street: e.target.value });
							}}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							id="zip"
							label="Zip Code"
							required
							fullWidth
							value={address.zip}
							error={address.zip ? false : true}
							onChange={(e) => {
								//setZip(e.target.value);
								setAddress({ ...address, zip: e.target.value });
							}}
						/>
					</Grid>
				</Grid>

				<Grid container direction="row" spacing={(1, 2)}>
					<Grid item xs={6}>
						<TextField
							id="city"
							name="city"
							label="City"
							required
							fullWidth
							value={address.city}
							error={address.city ? false : true}
							onChange={(e) => {
								setAddress({ ...address, city: e.target.value });
							}}
						/>
					</Grid>
					<Grid item xs={6}>
						<FormControl fullWidth>
							<InputLabel id="stateLabel">State</InputLabel>
							<Select
								id="state"
								label="State"
								placeholder="State"
								labelId="stateLabel"
								required
								fullWidth
								value={address.state}
								error={address.state ? false : true}
								onChange={(e) => {
									setAddress({ ...address, state: e.target.value });
								}}>
								<MenuItem value={address.state}>{address.state}</MenuItem>
								{usStates &&
									usStates.map((state) => (
										<MenuItem key={state} value={state.name}>
											{state.name}
										</MenuItem>
									))}
							</Select>
						</FormControl>
					</Grid>
				</Grid>

				<Grid container direction="row" spacing={(1, 2)}>
					<Grid item xs={6}>
						<TextField
							id="country"
							label="Country"
							required
							fullWidth
							value={address.country}
							error={address.country ? false : true}
							onChange={(e) => {
								//setCounty(e.target.value);
								setAddress({ ...address, country: e.target.value });
							}}
						/>
					</Grid>
					{/* <Grid item xs={6}>
						<TextField
							fullWidth
							id="address"
							label="Address"
							value={googleAddress}
							onChange={
								(e) => setGoogleAddress(e.target.value)
							}
						/>
					</Grid> */}
				</Grid>
			</DialogContent>
			<DialogActions className={classes.vendorDialogAction}>
				<Button
					onClick={addNewLocation}
					variant="contained"
					disableElevation
					className={classes.vendorDialogButton}>
					Submit
				</Button>
			</DialogActions>
		</Dialog>
	);
};
export default AddAssetLocation;
